// file: src/components/viewers/Viewer.jsx
import React, { useEffect } from 'react';
import PdfViewer from './PDFViewer';
import SpreadsheetViewer from './SpreadsheetViewer';
import WordDocViewer from './WordDocViewer';
import BlenderViewer from './BlenderViewer';
import FreeCADViewer from './FreeCADViewer';
import JupyterLabViewer from './JupyterLabViewer';
import KiCadViewer from './KiCadViewer';

// Import the new utility function
import { detectFileType } from '../../utils/fileUtils';

function Viewer({ file, pageToGo, pageJump }) {
  console.debug('[Viewer] Rendering viewer component');
  
  useEffect(() => {
    if (pageToGo !== undefined) {
      console.debug('[Viewer] Page navigation requested:', pageToGo);
    }
  }, [pageToGo]);

  if (!file) {
    console.warn('[Viewer] No file provided');
    return <div>No file selected.</div>;
  }

  // Prefer file.type if present, otherwise use detectFileType
  const type = file.type || detectFileType(file.name);
  switch (type) {
    case 'pdf':
      console.debug('[Viewer] Opening PDF file');
      
      // pageToGo is already validated in ViewerContext, so just pass it through
      return (
        <PdfViewer 
          file={file} 
          pageToGo={pageToGo} 
          pageJump={pageJump}
          key={`pdf-viewer-${file.id}`} 
        />
      );
    case 'csv':
      return <SpreadsheetViewer file={file} />;
    case 'doc':
    case 'docx':
      return <WordDocViewer file={file} key={`word-viewer-${file.id}`} />;
    case 'blender':
      return <BlenderViewer file={file} />;
    case 'freecad':
      return <FreeCADViewer file={file} />;
    case 'jupyterlab':
    case 'jupyterlab-iframe':
      return <JupyterLabViewer file={file} />;
    case 'kicad':
      return <KiCadViewer file={file} />;
    default:
      return <div>Unsupported file type: {type}</div>;
  }
}

// Wrap the component with React.memo
export default React.memo(Viewer);

